import {Injectable} from '@angular/core';

@Injectable()
export class PoolFaultTrackerService {

  private faultPoolMap = new Map<number, Set<number>>();

  trackAdded(faultIds: number[], poolIds: number[]) {
    for (const faultId of faultIds) {
      if (!this.faultPoolMap.has(faultId)) {
        this.faultPoolMap.set(faultId, new Set());
      }
      for (const poolId of poolIds) {
        this.faultPoolMap.get(faultId).add(poolId);
      }
    }
  }

  trackRemoved(faultIds: number[], poolIds: number[]) {
    for (const faultId of faultIds) {
      const pools = this.faultPoolMap.get(faultId);
      if (pools) {
        for (const poolId of poolIds) {
          pools.delete(poolId);
        }
      }
    }
  }

  getTrackedPoolIds(faultIds: number[]): Set<number> | null {
    const poolIds = new Set<number>();
    for (const faultId of faultIds) {
      const pools = this.faultPoolMap.get(faultId);
      if (!pools) { return null; }
      pools.forEach(id => poolIds.add(id));
    }
    return poolIds;
  }

  clearFault(faultId: number) {
    this.faultPoolMap.delete(faultId);
  }
}
